import axios from 'axios';

export const createFraudReport = (caseId, reasonCode, transactionIds) => {
    return axios.post('/api/createFraudReport', {
        caseId,
        reasonCode,
        transactionIds,
    });
};
